import QWLogo from 'assets/images/poweredBy_logo.png'

import { FC, Fragment } from 'react';
import config from 'config';
import { Controller, useFormContext } from 'react-hook-form';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizzesSelectors';
import { selectCurrentUser } from 'store/currentUser/currentUserSelectors';
// Types
import QuizTypes from 'types/QuizTypes';
import AccountFeatures from 'types/AccountFeatures';
// Components
import { Button } from 'components/Buttons';
import { Input, Toggle } from 'components/Controls';
// i18next
import { useTranslation } from 'react-i18next';
//
import { QRCodeCanvas } from "qrcode.react";

const PublicLeaderboardQrCode:FC = () => {
  const { t } = useTranslation('common');

  const quiz = useAppSelector(selectQuiz);
  const currentUser = useAppSelector(selectCurrentUser);

  const { control, watch } = useFormContext();

  const quizType = watch('type');
  const quizName = watch('quizName');
  const {
    enabled:publicLeaderboardEnabled,
    quizQRCodeEnabled:publicLeaderboardQuizQRCodeEnabled,
    quizQRCodeLink:publicLeaderboardQuizQRCodeLink

  } = watch('publicLeaderboard');

  const qrCodeLink = publicLeaderboardQuizQRCodeLink || `${config.quizURL}/quiz/${quiz?.quizNameSlug}`;

  const downloadQRCode = () => {
    const canvas = document.querySelector("#qrcode-canvas") as HTMLCanvasElement;
    if (!canvas) return;

    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `${quizName.replace(/\s/g, '-')}-Leaderboard-QR-Code.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  if (!quiz || quizType === QuizTypes.Personality) return null;
  return (
    <div className="mt-8">
      {publicLeaderboardEnabled && (
        <Fragment>
          <div className="flex items-center mb-4">
            <span className="block text-white text-base font-semibold mr-3">{t('ownerPage.quizForm.showQuizQRCode')}</span>
            <Controller
              control={control} name="publicLeaderboard.quizQRCodeEnabled"
              render={({ field: { onChange, value } }) => (
                <Toggle
                  id="publicLeaderboardQuizQRCodeEnabled"
                  checked={value}
                  onChange={onChange}
                />
              )}
            />
          </div>
          <span className="block text-gray-400 text-sm">{t('ownerPage.quizForm.showQuizQRCodeHint')}</span>
          {publicLeaderboardQuizQRCodeEnabled && (
            <Fragment>
              <div className="pt-6">
                <QRCodeCanvas
                  id="qrcode-canvas"
                  level="H"
                  size={175}
                  value={qrCodeLink}
                  imageSettings={currentUser?.account?.features?.includes(AccountFeatures.WhiteLabeling) ? undefined : {
                    src: QWLogo,
                    height: 30,
                    width: 80,
                    excavate: true
                  }}
                />
                <Button onClick={downloadQRCode} className="mt-2">Download QR Code</Button>
              </div>
              <div className="pt-4">
                <Controller
                  control={control} name="publicLeaderboard.quizQRCodeTitle"
                  render={({ field }) => (
                    <Input
                      {...field}
                      label={t('ownerPage.quizForm.quizQRCodeTitle')} id="publicLeaderboardQuizQRCodeTitle"
                      helperText={t('ownerPage.quizForm.quizQRCodeTitleHint')}
                    />
                  )}
                />
                <Controller
                  control={control} name="publicLeaderboard.quizQRCodeLink"
                  render={({ field }) => (
                    <Input
                      {...field}
                      label={t('ownerPage.quizForm.quizQRCodeLink')} id="publicLeaderboard.quizQRCodeLink"
                      helperText={t('ownerPage.quizForm.quizQRCodeLinkHint')}
                    />
                  )}
                />
              </div>
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  )
}

export default PublicLeaderboardQrCode;
